import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { fetchCurrentProducts } from './currentProducts';

export const recentProductIds = value => {
  try {
    const ids = JSON.parse(value || '[]');
    return Array.isArray(ids) ? [...new Set(ids.filter(id => typeof id === 'string' && /^[a-z0-9_-]+$/i.test(id)))].slice(0, 8) : [];
  } catch { return []; }
};

export default function useRecentlyViewed(consent, currentId) {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    setProducts([]);
    if (!consent) return;
    const previous = recentProductIds(Cookies.get('recentlyViewedProducts'));
    const ids = [...new Set([currentId, ...previous].filter(Boolean))].slice(0, 8);
    // Retain IDs only. Supplier imports can change publication, price and Swedish text daily.
    Object.keys(Cookies.get()).filter(key => key.startsWith('recentlyViewedProduct_')).forEach(key => Cookies.remove(key));
    Cookies.set('recentlyViewedProducts', JSON.stringify(ids), { expires: 7, sameSite: 'Lax' });
    const controller = new AbortController();
    fetchCurrentProducts(ids.filter(id => id !== currentId), controller.signal).then(results => {
      if (!controller.signal.aborted) setProducts(results.filter(result => result.product).map(result => result.product));
    });
    return () => controller.abort();
  }, [consent, currentId]);
  return products;
}
